import React from 'react';
import ChartJS from 'chart.js';

class Chart extends React.Component {
    static get chartTypes() {
        return {
            LINE: 'line',
            BAR: 'bar',
            PIE: 'pie',
            DOUGHNUT: 'doughnut',
            RADAR: 'radar',
            POLAR: 'polar'
        }
    }

    initChart(){
        if (this.chart) {
            this.chart.destroy();
        }
        let canvas = this.refs.chartCanvas;
        let type = this.props.type || Chart.chartTypes.LINE;
        this.chart = new ChartJS(canvas, {
            type: type,
            data: this.props.data,
            options: this.props.options || {}
        });
    }

    updateChart(){
        if (!this.chart) {
            this.initChart();
        }

        this.chart.data = this.props.data;

    }

    componentWillReceiveProps(){
        // console.log('props changed', this.chart);
        // if (this.chart) {
        //     this.updateChart(props.data);
        // }
    }

    shouldComponentUpdate() {
        return false;
    }

    componentDidMount(){
        this.initChart();
    }

    componentWillUnmount() {
        this.chart.destroy();
    }

    render () {
        return (
            <canvas {...this.props} className={['component-chart-component', this.props.className].join(' ')} ref="chartCanvas"></canvas>
        )
    }
}

export default Chart;



// WEBPACK FOOTER //
// ./web-app/components/chart.jsx